module.exports = __webpack_public_path__ + "img/kefu_.64bdf696.png";